import React, { useEffect } from "react";

function AffordabilityWidget() {

    function loadWidget() { 
      window.payuAffordability.init({  key: process.env.REACT_APP_PAYU_MKEY,
  amount: 10000});
    }
  
    function appendScript() {
      let myScript = document.getElementById("payu-affordability-widget");
      if(!myScript){	
          myScript = document.createElement('script');
          myScript.setAttribute('src', "https://jssdk-uat.payu.in/widget/affordability-widget.min.js");
          myScript.id="payu-affordability-widget";
          document.body.appendChild(myScript);
      }
      myScript.addEventListener("load", loadWidget, true);
    }
  
    useEffect(() => {
        appendScript();
    }, [])

    return (
      <div id="payuWidget">Payu Widget </div> 
    )
}

export default AffordabilityWidget;